import { Table as ShiftsTable } from '@/components/shift/table'

interface Props {
  eventId: string
}

export const EditShifts = ({ eventId }: Props) => {
  return (
    <>
      <ShiftsTable
        filters={{ eventIdEq: eventId }}
        hiddenColumns={['Event']}
        pageSize={10}
        title="Shifts"
        createable
        fixedHeight
        updateable
      />
    </>
  )
}
